export default "__VITE_ASSET__9116d2a8__"